/* eslint semi:0 */
import { appDispatcher } from '../../application/AppDispatcher'
import { namespacedConsts } from '../../utils/object'

const CONSTS = namespacedConsts({
  ACTIONS: {
    TEMPLATE_READY: true,
    EXTERNAL_LOADED: true,
    PLAYER_ENTER_VIEWPORT: true,
    PLAYER_EXIT_VIEWPORT: true,
    PLAYER_OLDEST_IN_VIEWPORT: true, // oldest means that this player is in the viewport more time now then any other player in the viewport
    VIDEO_STARTED_PLAYING: true,
  },
})

export const TYPES = CONSTS.ACTIONS

export const templateReady = player => {
  appDispatcher.dispatchAction.view({
    type: CONSTS.ACTIONS.TEMPLATE_READY,
    player,
  })
}

export const externalLoaded = () => {
  appDispatcher.dispatchAction.external({
    type: CONSTS.ACTIONS.EXTERNAL_LOADED,
  })
}

export const playerEnterViewport = playerId => {
  appDispatcher.dispatchAction.external({
    type: CONSTS.ACTIONS.PLAYER_ENTER_VIEWPORT,
    playerId,
  })
}

export const playerExitViewport = playerId => {
  appDispatcher.dispatchAction.external({
    type: CONSTS.ACTIONS.PLAYER_EXIT_VIEWPORT,
    playerId,
  })
}

export const videoStartedPlaying = payload => {
  appDispatcher.dispatchAction.external({
    type: CONSTS.ACTIONS.VIDEO_STARTED_PLAYING,
    payload,
  })
}

export const actions = {
  TYPES,
  templateReady,
  externalLoaded,
  playerEnterViewport,
  playerExitViewport,
  videoStartedPlaying,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/brightcovePlayerActions.js